module.exports = __webpack_public_path__ + "img/chrome_reader_mode.512a94a1.svg";